import React, { useCallback } from 'react';
import { Box, Button } from '@mui/material';
import styles from './ForgetPassword.module.css';
import { CommonPageStep, ForgetPasswordPageStep } from '../..';
import { useAppSelector } from '../../../store/hooks';
import {
  selectAppPageStep,
  setAppPageStep,
} from '../../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../../store/store';
import {
  ForgetPasswordElement,
  ForgetPasswordElementInterface,
} from '../ForgetPasswordElement';

export const MobileView = (): JSX.Element => {
  // REDUX
  const appPageStep = useAppSelector(selectAppPageStep);

  // ELEMENT
  const forgetPasswordElement: ForgetPasswordElementInterface =
    ForgetPasswordElement();
  return (
    <React.Fragment>
      <header className={styles.headerGroup} id="common-navi-bar">
        <img
          className={styles.bbaLogoIcon}
          id="entry-header"
          alt=""
          src="assets/common/bba-logo.svg"
        />
      </header>
      <Box className={styles.mainGroupBox}>
        <Box className={styles.mainGroupTitleBox}>
          <img
            className={styles.loginMainBackButtonIcon}
            id="login-main-back-button"
            alt=""
            src="assets/login/login-main-back-button.svg"
            onClick={() => {
              if (appPageStep === ForgetPasswordPageStep.SENT) {
                outsideComponentDispatch(
                  setAppPageStep(ForgetPasswordPageStep.SUBMIT),
                );
              } else {
                outsideComponentDispatch(setAppPageStep(CommonPageStep.LOGIN));
              }
            }}
          />
          {appPageStep === ForgetPasswordPageStep.SUBMIT ? (
            <span className={styles.mainGroupTitle}>Forget Password</span>
          ) : null}
          {appPageStep === ForgetPasswordPageStep.SENT ? (
            <span className={styles.mainGroupTitle}>Email has been sent!</span>
          ) : null}
        </Box>
        <Box style={{ marginTop: '26px' }}>
          <Box className={styles.mainGroupBoxDescription}>
            {appPageStep === ForgetPasswordPageStep.SUBMIT ? (
              <React.Fragment>
                <span
                  className={styles.mainGroupBoxDescriptionText}
                >{`Enter your registered email.`}</span>
              </React.Fragment>
            ) : null}
            {appPageStep === ForgetPasswordPageStep.SENT ? (
              <React.Fragment>
                <span
                  className={styles.mainGroupBoxDescriptionText}
                >{`Please check your inbox and click in the received link to reset password.`}</span>
              </React.Fragment>
            ) : null}
          </Box>
        </Box>
        <Box className={styles.mainGroupForgetPasswordBox}>
          {appPageStep === ForgetPasswordPageStep.SUBMIT ? (
            <React.Fragment>
              {forgetPasswordElement.emailInputTextfield}
            </React.Fragment>
          ) : null}
          {appPageStep === ForgetPasswordPageStep.SENT ? (
            <React.Fragment>
              {forgetPasswordElement.sentEmailIcon}
            </React.Fragment>
          ) : null}
        </Box>
        {appPageStep === ForgetPasswordPageStep.SUBMIT ? (
          <React.Fragment>
            <Box className={styles.mainGroupForgetEmailBox}>
              {forgetPasswordElement.forgetEmailButton}
            </Box>
            {forgetPasswordElement.submitButton}
          </React.Fragment>
        ) : null}
      </Box>
    </React.Fragment>
  );
};
